import React, { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { useTypedDispatch } from "store";
import { useSelector } from "react-redux";
import { checkChatKitAvailability } from "features/AssistantPages/AssistantPagesActions";
import { AssistantChat } from "components/AssistantChat";
import { getAssistantPageCode } from "api/utils/getAssistantPageCode";
import { RootState } from "store/rootReducer";
import { routes } from "config/routes";

export const AssistantChatLayout = () => {
  const location = useLocation();
  const dispatch = useTypedDispatch();
  const code = getAssistantPageCode(location.pathname);
  const match = matchPath(routes.private.viewProperties, location.pathname);
  const propertyId = match?.params?.id ?? undefined;

  const isChatKitAvailability = useSelector(
    (state: RootState) => state.AssistantPagesReducer.isChatKitAvailable
  );

  useEffect(() => {
    if (!code) return;

    dispatch(checkChatKitAvailability(code));
  }, [code]);

  return (
    <>
      {code && isChatKitAvailability?.[code] === true && (
        <AssistantChat code={code} propertyId={propertyId} />
      )}
    </>
  );
};
